<script>
export default {
  name: "formatterModulosRRHH",
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  functional: true,

  render(createElement, context) {
    let { column } = context.data.attrs;
    let { row } = context.props;

    let Type = String;
    let Status = String;
    let customStyle = String;

    if (
      Object.prototype.hasOwnProperty.call(row, "SupervisorApproval") &&
      column === "SupervisorApproval"
    ) {
      if (row.SupervisorApproval == "Pendiente") {
        Type = "amarillo";
        Status = row.SupervisorApproval;
        customStyle =
          "color: black; font-weight:bold; text-align:center; background-color:rgba(504, 95, 52, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.SupervisorApproval == "Rechazado") {
        Type = "Rojo";
        Status = row.SupervisorApproval;
        customStyle =
          "color: red; font-weight:bold; text-align:center; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.SupervisorApproval == "Aprobado") {
        Type = "Verde";
        Status = row.SupervisorApproval;
        customStyle =
          "color: green; font-weight:bold; text-align:center; background-color:rgba(87, 255, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "RRHH_Approval") &&
      column === "RRHH_Approval"
    ) {
      if (row.RRHH_Approval == "Pendiente") {
        Type = "amarillo";
        Status = row.RRHH_Approval;
        customStyle =
          "color: black; font-weight:bold; text-align:center; background-color:rgba(504, 95, 52, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.RRHH_Approval == "Rechazado") {
        Type = "Rojo";
        Status = row.RRHH_Approval;
        customStyle =
          "color: red; font-weight:bold; text-align:center; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.RRHH_Approval == "Aprobado") {
        Type = "Verde";
        Status = row.RRHH_Approval;
        customStyle =
          "color: green; font-weight:bold; text-align:center; background-color:rgba(87, 255, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.RRHH_Approval == "Ejecutado") {
        Type = "Blanco";
        Status = row.RRHH_Approval;
        customStyle =
          "color: white; font-weight:bold; text-align:center; background-color:rgba(127, 87, 255, 1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    }
    return createElement();
  }
};
</script>

<style scoped>
.Azul {
  color: blue;
}
.Verde {
  color: green;
}
.amarillo {
  background-color: yellow;
}
.Naranja {
  color: orange;
}
.Rojo {
  color: rgba(255, 0, 0, 0.712);
}
.Negro {
  color: black;
}

.Blanco {
  color: white;
}
</style>
